import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MdSnackBar } from '@angular/material';
import { Location } from '@angular/common';
import { NavigationService } from '@services/navigation-service';
import { DialogsService } from '@services/dialogs-service';
import { PATH_FINANCIERA } from '../../../../navigation/navigation.module';
import { PricePipe } from '@utils/pipes';
import { PermisosService } from '@services/permisos-service';
import { FinancieraService } from '@services/financiera-service';
import { SpinnerService } from '@services/spinner-service';
import * as moment from 'moment';
import {dateToUnixTime} from "@utils/DateHelper";
import {PageHeaderComponent} from '@common/page-header';

@Component({
  selector: 'app-new-precio-financiera',
  templateUrl: './new-precio-financiera.component.html',
  styleUrls: ['./new-precio-financiera.component.scss']
})
export class NewPrecioFinancieraComponent implements OnInit {

  columns = ['Entidad', 'Subtipo', 'Precio', 'Fecha'];

  @ViewChild('precioInput') priceInput: ElementRef;

  entity = [];

  maxDate = moment().add(1, 'days').toDate();

  public dummyDateContainer = null;
  public editFechaId = 0;
  @ViewChild('datePicker') datePicker;
  @ViewChild(PageHeaderComponent) pageHeader: PageHeaderComponent;

  constructor(private router: Router,
              private location: Location,
              private dialogsService: DialogsService,
              private navService: NavigationService,
              private snackBar: MdSnackBar,
              private pricePipe: PricePipe,
              private permisosService: PermisosService,
              private financieraService: FinancieraService,
              private spinnerService: SpinnerService) {
    this.permisosService.verificarAccesoDeURL();
    this.financieraService.loadOptions();
    this.financieraService.Options.subscribe(res => {
      if (res) {
        this.entity = [];
        res.forEach(ent => {
          ent.Subentidades.forEach(sub => {
            if (sub.Visibilidad) {
              const item = {
                entidad: ent.Nombre,
                subentidad: sub.Nombre,
                Id: sub.ID,
              };
              this.entity.push(item);
            }
          });
        });

        this.entity.forEach(x => {
          x['Precio'] = null;
          x['InputVisible'] = false;
          x['error'] = false;
          x['errorValue'] = '';
          x['tmp'] = '';
          x['fecha'] = moment().toDate();
        });
      }
    });
  }

  ngOnInit() {  }

  navigateBack() {
    let arePricesLoaded = false;
    this.entity.forEach(x => {
      if (x.Precio > 0) {
        arePricesLoaded = true;
      }
    });
    if (arePricesLoaded) {
      this.dialogsService.confirm(null,
        '¿Está seguro de salir sin cargar estos precios?',
        'SÍ, ACEPTAR',
        'NO, CANCELAR')
        .subscribe(res => {
          if (res) {
            this.pageHeader.catchEnded();
          }
        });
    } else {
      this.pageHeader.catchEnded();
    }
  }

  displayInput(row) {
    row.InputVisible = true;
    row.tmp = row.Precio ? row.Precio.toString() : row.error ? row.errorValue : '';
    setTimeout(() => {
      this.priceInput.nativeElement.focus();
    }, 100);
  }

  savePriceInput(row) {
    if (!row.tmp.length) {
      row.Precio = null;
      row.error = false;
      row.errorValue = '';
    } else {
      const temp = row.tmp.replace(',', '.');
      if (Number.isNaN(Number(temp))) {
        row.error = true;
        row.Precio = null;
        row.errorValue = row.tmp;
      } else if (Number(temp) > 0 && Number(temp) < 1000000000) {
        row.Precio = Number(temp);
        row.error = false;
        row.errorValue = '';
      } else {
        row.error = true;
        row.Precio = null;
        row.errorValue = row.tmp;
      }
    }
    row.InputVisible = false;
  }

  onSubmit() {
    // chequeamos si hay algun error
    if (this.entity.findIndex(v => v.error === true) >= 0) {
      this.snackBar.open('Uno o mas precios tiene errores', '', {
        duration: 2000,
      });
      return;
    }

    if (this.entity.findIndex(v => v.Precio !== null) < 0) {
      this.snackBar.open('Debe cargarse al menos un precio', '', {
        duration: 2000,
      });
      return;
    }

    // primero chequeamos que haya al menos un precio cargado
    let precios: any = this.entity.filter(x => x.Precio !== null);
    if (precios.length) {

      let string = '';

      precios.forEach(x => {
        string = `${string} ${x.entidad}&nbsp;-&nbsp;${x.subentidad}: ${this.pricePipe.transform(x.Precio, 'fill')}&nbsp;-&nbsp;${moment(x.fecha).format('DD/MM/YY')}<br>`;
      });

      this.dialogsService.confirm('¿Está seguro que desea cargar estos precios?', string, 'ACEPTAR', 'CANCELAR')
        .subscribe(res => {
          if (res) {
            precios = precios.map(x => ({
              Valor: x.Precio,
              Subent_Fin_ID: x.Id,
              Mon_ID: 1,
              FechaCotizacion: dateToUnixTime(x.fecha),
            }));
            this.spinnerService.setShowFlag(true);
            this.financieraService.crearPreciosFinanciera(precios)
              .subscribe(x => {
                this.spinnerService.setShowFlag(false);
                if (x) {
                  this.snackBar.open('Se han enviado a validar los Precios', '', {
                    duration: 2000,
                  });
                  this.router.navigateByUrl('/' + PATH_FINANCIERA);
                }
              }, err => {
                this.spinnerService.setShowFlag(false);
              });
          }
        });
    }
  }

  getFecha(row) {
    return moment(row.fecha).format('DD/MM/YY');
  }

  showDatePicker(e) {
    // guardamos la posicion del picker seleccionado
    this.editFechaId = e;
    this.dummyDateContainer = null;
    setTimeout(_ => {
      this.datePicker.open();
    }, 100);
  }

  onEditFecha(e) {
    // no se envia la row correcta al editar por lo que guardamos la posicion editada y la usamos como ID (this.editFechaId)
    // verificar que no se pase de HOY
    this.entity[this.editFechaId].fecha = moment(e).toDate();
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/financiera/new-precio-financiera/new-precio-financiera.component.ts